module.exports = __webpack_public_path__ + "static/03-c3d457a773a812ddb0a7f7b176359ccd.jpg";